module.exports = __webpack_public_path__ + "img/toEvaluated-1.7697c0d4.png";